/* Grace Spring — storefront behaviour.
   Ports the interactive bits of the repo's React components to vanilla JS:
   quantity steppers (ShopSection), ZIP checker (ZipChecker), mobile menu
   (SiteHeader), live cart count (CartDrawer) and the scroll-reveal. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-up], [data-qty-down]');
    if (!btn) return;
    var stepper = btn.closest('.qty-stepper');
    var out = stepper.querySelector('[data-qty-value]');
    var input = stepper.querySelector('[data-qty-input]');
    var next = parseInt(out.textContent, 10) + (btn.hasAttribute('data-qty-up') ? 1 : -1);
    if (next < 1) next = 1;
    if (next > 99) next = 99;
    out.textContent = next;
    if (input) input.value = next;
  });

  /* ---------- ZIP checker ----------
     Messages come from data-* attributes. Reading them from element content
     would drag in the theme editor's <!-- BEGIN setting: ... --> wrappers,
     which then render as visible text. */
  document.querySelectorAll('[data-zip-form]').forEach(function (form) {
    var card = form.closest('.delivery-card');
    var result = card.querySelector('[data-zip-result]');

    var prefixes = (form.dataset.prefixes || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var zip = (form.querySelector('input[name="zip"]').value || '').trim();

      if (!/^\d{5}$/.test(zip)) {
        result.className = 'zip-result no';
        result.textContent = form.dataset.msgInvalid || 'Please enter a 5-digit ZIP code.';
        return;
      }

      var covered = prefixes.some(function (p) { return zip.indexOf(p) === 0; });
      result.className = 'zip-result ' + (covered ? 'ok' : 'no');
      result.textContent = covered ? form.dataset.msgOk : form.dataset.msgNo;
    });
  });

  /* ---------- mobile menu ---------- */
  var menuBtn = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (menuBtn && menu) {
    menuBtn.addEventListener('click', function () {
      var open = menu.hasAttribute('hidden');
      if (open) menu.removeAttribute('hidden'); else menu.setAttribute('hidden', '');
      menuBtn.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', function (e) {
      if (menu.hasAttribute('hidden')) return;
      if (menu.contains(e.target) || menuBtn.contains(e.target)) return;
      menu.setAttribute('hidden', '');
      menuBtn.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hasAttribute('hidden')) {
        menu.setAttribute('hidden', '');
        menuBtn.setAttribute('aria-expanded', 'false');
        menuBtn.focus();
      }
    });
  }

  /* ---------- cart count ----------
     Add-to-cart posts through Shopify's form action; intercept so the count
     updates without a page load, falling back to a normal submit on failure. */
  var counts = document.querySelectorAll('[data-cart-count]');
  function setCount(n) {
    counts.forEach(function (el) { el.textContent = n; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action$="/cart/add"]')) return;

    // Already added: the same button is now "View cart".
    if (form.dataset.added) {
      e.preventDefault();
      window.location.href = document.body.dataset.cartUrl || '/cart';
      return;
    }
    if (!window.fetch) return; // let the browser do it the old way

    e.preventDefault();
    var submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        markAdded(form, submit);
        if (document.body.dataset.atcToast) addedToast();
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (submit) submit.disabled = false; });
  });

  /* ---------- "View cart" on the add button ----------
     After a successful add, the product's own button turns into a link to the
     cart (label: Theme settings -> Add-to-cart button). Changing the quantity
     or the variant turns it back into "Add to Order", so a second add is one
     tap away. */
  function markAdded(form, submit) {
    var label = document.body.dataset.atcButton;
    if (!submit || !label) return;
    form.dataset.added = '1';
    submit.classList.add('is-added');
    submit.textContent = label;
  }
  function resetAdded(form) {
    if (!form || !form.dataset.added) return;
    delete form.dataset.added;
    var submit = form.querySelector('[type="submit"]');
    if (!submit) return;
    submit.classList.remove('is-added');
    // a sold-out variant has already relabelled and disabled the button
    if (submit.dataset.labelAdd && !submit.disabled) submit.textContent = submit.dataset.labelAdd;
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-qty-up], [data-qty-down], [data-swatch]');
    if (!trigger) return;
    var scope = trigger.closest('[data-product-card]') || trigger.closest('form');
    if (!scope) return;
    if (scope.matches('form[action$="/cart/add"]')) resetAdded(scope);
    else scope.querySelectorAll('form[action$="/cart/add"]').forEach(resetAdded);
  });

  /* ---------- toast ----------
     Optional bottom message after an add (Theme settings -> Add-to-cart
     button -> "Also show a message at the bottom"); off by default, since the
     button itself turns into "View cart". Settings arrive as data-* on <body>.
     It stays up while hovered or focused so the link can't vanish under a
     cursor or a keyboard. */
  var toastEl, toastMsg, toastLink;
  function toast(msg, link, ms) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast success';
      toastEl.setAttribute('role', 'status');
      toastMsg = document.createElement('span');
      toastLink = document.createElement('a');
      toastLink.className = 'toast-action';
      toastEl.appendChild(toastMsg);
      toastEl.appendChild(toastLink);
      document.body.appendChild(toastEl);
      var hold = function () { clearTimeout(toastEl._t); };
      var release = function () { schedule(toastEl._ms); };
      toastEl.addEventListener('mouseenter', hold);
      toastEl.addEventListener('focusin', hold);
      toastEl.addEventListener('mouseleave', release);
      toastEl.addEventListener('focusout', release);
    }
    toastMsg.textContent = msg;
    toastLink.hidden = !link;
    if (link) {
      toastLink.textContent = link.label;
      toastLink.href = link.href;
    }
    toastEl.classList.toggle('has-action', !!link);
    toastEl.classList.add('show');
    toastEl._ms = ms || 2400;
    schedule(toastEl._ms);
  }
  function schedule(ms) {
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('show'); }, ms);
  }
  function addedToast() {
    var d = document.body.dataset;
    var seconds = parseFloat(d.atcSeconds) || 5;
    toast(d.atcMessage || 'Added to your order',
          null,
          seconds * 1000);
  }

  /* ---------- product gallery ---------- */
  var pdpImage = document.getElementById('pdp-image');
  if (pdpImage) {
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        pdpImage.src = thumb.dataset.pdpThumb;
        document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', String(t === thumb));
        });
      });
    });
  }

  /* ---------- product variant switching ---------- */
  var variantData = document.querySelector('[data-pdp-variants]');
  if (variantData) {
    var variants;
    try { variants = JSON.parse(variantData.textContent); } catch (err) { variants = []; }

    var selects = Array.prototype.slice.call(document.querySelectorAll('[data-pdp-option]'));
    var idInput = document.querySelector('[data-pdp-variant-id]');
    var submit = document.querySelector('[data-pdp-submit]');
    var priceEl = document.querySelector('.pdp-price');

    var sync = function () {
      var chosen = selects.map(function (s) { return s.value; });
      var match = variants.find(function (variant) {
        return variant.options.every(function (opt, i) { return opt === chosen[i]; });
      });

      if (!match) return;
      if (idInput) idInput.value = match.id;

      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available
          ? submit.dataset.labelAvailable || submit.textContent
          : 'Sold out';
      }
      // price arrives as cents; render with the page's existing currency symbol
      if (priceEl && typeof match.price === 'number') {
        var symbol = (priceEl.textContent.match(/^[^\d]*/) || [''])[0];
        priceEl.textContent = symbol + (match.price / 100).toFixed(2);
      }
    };

    if (submit) submit.dataset.labelAvailable = submit.textContent.trim();
    selects.forEach(function (s) { s.addEventListener('change', sync); });
  }

  /* ---------- product-card variant swatches ----------
     Each swatch carries its own variant data as data-* attributes, so there
     is no JSON to parse and prices arrive pre-formatted by Liquid's `money`
     filter — no currency formatting in JS, which is where these usually rot. */
  document.querySelectorAll('[data-product-card]').forEach(function (card) {
    var swatches = card.querySelectorAll('[data-swatch]');
    if (!swatches.length) return;

    var image = card.querySelector('[data-card-image]');
    var price = card.querySelector('[data-card-price]');
    var compare = card.querySelector('[data-card-compare]');
    var name = card.querySelector('[data-card-variant-name]');
    var unit = card.querySelector('[data-card-unit]');
    var idInput = card.querySelector('[data-card-variant-id]');
    var submit = card.querySelector('[data-card-submit]');

    function select(swatch) {
      var d = swatch.dataset;

      swatches.forEach(function (s) {
        var on = s === swatch;
        s.classList.toggle('is-selected', on);
        s.setAttribute('aria-pressed', String(on));
      });

      if (image && d.variantImage) image.src = d.variantImage;
      if (price && d.variantPrice) price.textContent = d.variantPrice;
      if (name && d.variantTitle) name.textContent = d.variantTitle;
      if (unit && d.variantUnit) unit.textContent = d.variantUnit;
      if (idInput && d.variantId) idInput.value = d.variantId;

      if (compare) {
        if (d.variantCompare) {
          compare.textContent = d.variantCompare;
          compare.removeAttribute('hidden');
        } else {
          compare.textContent = '';
          compare.setAttribute('hidden', '');
        }
      }

      if (submit) {
        var available = d.variantAvailable === 'true';
        submit.disabled = !available;
        submit.textContent = available
          ? submit.dataset.labelAdd
          : submit.dataset.labelSoldOut;
      }
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () { select(swatch); });
    });

    /* arrows: only meaningful when the track actually overflows */
    var track = card.querySelector('[data-swatch-track]');
    var prev = card.querySelector('[data-swatch-prev]');
    var next = card.querySelector('[data-swatch-next]');

    if (track && prev && next) {
      var step = function () { return Math.max(track.clientWidth * 0.7, 80); };

      var sync = function () {
        var overflows = track.scrollWidth - track.clientWidth > 2;
        if (!overflows) {
          prev.hidden = true;
          next.hidden = true;
          return;
        }
        prev.hidden = track.scrollLeft <= 1;
        next.hidden = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
      };

      prev.addEventListener('click', function () { track.scrollLeft -= step(); });
      next.addEventListener('click', function () { track.scrollLeft += step(); });
      track.addEventListener('scroll', sync);
      window.addEventListener('resize', sync);

      sync();
      // images load late and change scrollWidth, so re-check once settled
      window.addEventListener('load', sync);
      setTimeout(sync, 300);
    }
  });

  /* ---------- scroll reveal ---------- */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var targets = document.querySelectorAll('.offer-card, .step-card, .product-card, .review-card');
    targets.forEach(function (el) { el.classList.add('reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('reveal-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }
})();
